import { render } from "./ConfGenerali.vue?vue&type=template&id=99b8cb38&scoped=true"
import script from "./ConfGenerali.vue?vue&type=script&lang=js"
export * from "./ConfGenerali.vue?vue&type=script&lang=js"

import "./ConfGenerali.vue?vue&type=style&index=0&id=99b8cb38&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-99b8cb38"]])

export default __exports__